import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/cn'

export function Spinner({ size = 24, className }: { size?: number; className?: string }) {
  return <Loader2 size={size} className={cn('animate-spin text-primary', className)} />
}

/** Full-viewport centered loader (auth resolution, route Suspense fallback). */
export function FullPageLoading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex h-full min-h-[60vh] w-full flex-col items-center justify-center gap-4">
      <Spinner size={44} />
      <p className="text-body-sm font-medium text-slate-500">{label}</p>
    </div>
  )
}
